import React, { useRef, useEffect, useState } from 'react'

import { Box, Text } from '@vividseats/vivid-ui-kit'
import { useIntersectionObserver } from 'usehooks-ts'

import { STYLES } from '@/constants'

import { ConfettiWrapper } from './components/confetti-wrapper'
import { Perks } from './components/perks'
import { PerksSlider } from './components/perks-slider'
import styles from './styles.module.scss'

const DESKTOP_WIDTH_PX = STYLES.breakpoint.desktop
const DESKTOP_HEIGHT_PX = 260
const MOBILE_HEIGHT_PX = 224

const RewardPerks: React.FC = () => {
    const ref = useRef<HTMLDivElement | null>(null)
    const [windowWidth, setWindowWidth] = useState(0)

    const entry = useIntersectionObserver(ref, {})
    useEffect(() => {
        const updateWindowWidth = () => setWindowWidth(document.body.clientWidth)
        updateWindowWidth()
        window.addEventListener('resize', updateWindowWidth)
        return () => window.removeEventListener('resize', updateWindowWidth)
    }, [])

    const perks = [
        <Box className={styles.firstSubBox} key="1">
            <Text className={styles.firstSub}>
                Free birthday <br /> reward
            </Text>
        </Box>,
        <Text className={styles.secondSub} key="2">
            Surprise seat <br /> upgrades
        </Text>,
        <Box className={styles.thirdSubBox} key="3">
            <Text className={styles.thirdSub}>
                Invites to <br /> VIP events
            </Text>
        </Box>,
    ]

    const title = (
        <Box display="flex" justify="center">
            <Text className={styles.title}>Enjoy exclusive perks</Text>
        </Box>
    )

    return (
        <div ref={ref} className={styles.container}>
            {windowWidth >= DESKTOP_WIDTH_PX ? (
                <Perks width={windowWidth} height={DESKTOP_HEIGHT_PX} title={title} perks={perks} />
            ) : (
                <PerksSlider title={title} perks={perks} />
            )}
            <ConfettiWrapper
                width={windowWidth}
                height={windowWidth < DESKTOP_WIDTH_PX ? MOBILE_HEIGHT_PX : DESKTOP_HEIGHT_PX}
                shouldParty={!!entry?.isIntersecting}
            />
        </div>
    )
}

export default RewardPerks
